// import Rellax from 'rellax/rellax.js';
//
// export default {
//   init() {
//     new Rellax('.home-project .wp-block-column:first-child .wp-block-image', {
//       speed: -0.75,
//     });
//     new Rellax('.home-project .wp-block-column:last-child .wp-block-image', {
//       speed: 0.75,
//     });
//   },
// };
